import React, { useEffect, useState } from "react";
import "./Home.css";

import skillsJobImage from "../../assets/images/skillsjob.jpg";
import animiSkills from "../../assets/images/animiskills.jpg";
import workersConnectedImg from "../../assets/images/workersCnnected-box1.jpg";
import voiceAgent from "../../assets/images/Vocie_Agent_For_Services_Section.png";
import growthPic from "../../assets/images/growthpic-1.jpg";
import growthPersonImage from "../../assets/images/growthPerson.jpg";
import growthImage from "../../assets/images/groupImage-2.webp";
import growthImageGirl from "../../assets/images/growthImageGirl.jpeg";
import groupImage from "../../assets/images/group.png";
import customerSupportImage from "../../assets/images/customer-support.png";
import backgroundImage from "../../assets/images/backgroundImage.avif";

import HeroSection from "../../components/HeroSection/HeroSection";
import HeroImage from "../../assets/images/servicespage_background_image.png";
import quoteImage from "../../assets/images/quote.png";
import briefcaseImage from "../../assets/images/briefcase.png";
import MobileMockup from "../../components/MobileMockup/MobileMockup";
import Footer from "../../components/Footer";

const Home = () => {
  return (
    <>
      <div className="home-container">
        <HeroSection
          cName="hero-section"
          title="Welcome to Chauwk"
          text="Explore our services and offerings."
          sideText="24/7 Human-like AI Support Agents"
          heroImg={HeroImage}
          buttonText="Explore"
          url="#features"
          btnClass="show"
        />
        <div className="our-features" id="features">
          {/* <div className="features">
            <p style={{ textAlign: "center", margin: "0 auto", maxWidth: "900px" }}>
              <span className="highlight-c">C</span>hauwk helps enterprises build a
              future-ready ecosystem by uplifting workforce capability through
              continuous skilling and welfare enablement, while also delivering
              intelligent AI voice agent solutions for customer support, lead
              engagement, sales, and business communication at scale.
            </p>
          </div> */}
          <div className="features" style={{ marginLeft: "0px" }}>
            <p
              style={{
                textAlign: "center",
                width: "70%",
                margin: "44px auto 30px auto",
              }}
              ref={(el) => {
                if (el) {
                  el.style.setProperty("text-align", "center", "important");
                  el.style.setProperty("width", "70%", "important");
                  el.style.setProperty("margin", "44px auto 30px auto", "important");
                }
              }}
            >
              <span className="highlight-c">C</span>hauwk helps enterprises build a
              future-ready ecosystem by uplifting workforce capability through
              continuous skilling and welfare enablement, while also delivering
              intelligent AI voice agent solutions for customer support, lead
              engagement, sales, and business communication at scale.
            </p>
          </div>
        </div>
        <div className="rectangles-container">
          <div className="rect rect-1">
            <i className="fa-regular fa-handshake"></i>
            <h3>Empower Workforce</h3>
            <p>
              Building AI powered enterprise solutions for collaboration and
              growth.
            </p>
          </div>
          <div className="rect rect-2">
            <i className="fas fa-users"></i>
            <h3>Skilled Frontline</h3>
            <p>Empowering Enterprises with <br /> resources to enhance their skills.</p>
          </div>
          <div className="rect rect-3">
            <i className="fa-solid fa-lightbulb"></i>
            <h3>Learn Smart</h3>
            <p>
              Gamified Interactive tools to make learning engaging and efficient.
            </p>
          </div>
          <div className="rect rect-4">
            <i className="fa-solid fa-chart-line"></i>
            <h3>Job Connections</h3>
            <p>Connecting job seekers with AI recommended opportunities.</p>
          </div>
        </div>
        <div
          className="development-heading"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <h2>
            Do you also face the following challenges with your entry level
            work-force?
          </h2>
        </div>
        <div className="four-box-section">
          <div className="small-box">
            <div className="backdrop-box"></div>
            <img src={briefcaseImage} alt="Briefcase" className="box-image" />
            <h3 className="mt-2">
              Difficulty in finding reliable, skilled workers?
            </h3>
            <p className="mt-neg-8">
              Deep expertise delivering unparalleled solutions and insights for
              your success
            </p>
            <div className="small-blue-h-line"></div>
          </div>

          <div className="small-box">
            <div className="backdrop-box"></div>
            <img src={groupImage} alt="People" className="box-image" />
            <h3 className="mt-2">Skill gaps affecting efficiency?</h3>
            <p className="mt-10">
              Ai Voice Agents dedicated to exceeding expectations and achieving
              success
            </p>
            <div className="small-blue-h-line"></div>
          </div>

          <div className="small-box">
            <div className="backdrop-box"></div>
            <img
              src={customerSupportImage}
              alt="Customer Support"
              className="box-image"
            />
            <h3 className="mt-neg-3">
              Lack of loyalty leading to low productivity ?
            </h3>
            <p className="mt-10">
              Tailored support and guidance ensuring reliability and innovation
              every step of the way
            </p>
            <div className="small-blue-h-line"></div>
          </div>
        </div>
        <div className="wrapper">
          <div className="services-title">
            <h6>WHAT WE OFFER</h6>
            <div className="services-description">
              At Chauwk, we are committed to driving innovation and excellence by
              offering cutting-edge AI Solutions that enhance efficiency, optimize
              processes, and empower businesses to achieve their goals
            </div>
          </div>

          {/* 
          <div className="growth">
            <div className="growth-content">
              <div className="half-circle">
                <h1>2+</h1>
              </div>
              <h3>years of </h3>
              <h3>Experience</h3>
            </div>
            <div className="growth-section-1">
              <img src={growthPic} alt="Growth" className="growth-image" />
            </div>
          </div>

          <div className="growthpeople">
            <img
              src={growthPersonImage}
              alt="Growth People"
              className="growth-people-image"
            />
          </div>

          <div className="growth-Image-2">
            <img src={growthImage} alt="Growth Image" />
          </div>
          <div className="growth-image-container">
            <img src={growthImageGirl} alt="Growth Image Girl" />
          </div>
          <div className="growth-text">
            <div className="quote-container">
              <img src={quoteImage} alt="Quote" className="quote-image" />
            </div>
            <p>
              The tools and support we received were pivotal in retaining our
              labour manpower and helped in revenue boost. This success wouldn’t
              have been possible without the multi-lingual and gamified HRTech
              solutions provided...
              <div className="quote-2">
                <img src={quoteImage} alt="Quote" className="quote-image" />
              </div>
            </p>
          </div>
          */}
          
          <div style={{
            width: "90%",
            maxWidth: "940px",
            aspectRatio: "16 / 9",
            margin: "60px auto",
            borderRadius: "24px",
            background: "#ffffff",
            padding: "8px",
            boxShadow: "0 20px 50px rgba(0, 0, 0, 0.15)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <div style={{
              width: "100%", 
              height: "100%", 
              borderRadius: "16px", 
              overflow: "hidden",
              backgroundColor: "#000",
            }}>
              <iframe 
                style={{ width: "100%", height: "100%", border: "none", display: "block" }}
                src="https://www.youtube.com/embed/-ZBSxzR6iG0" 
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="our-impact" style={{ marginTop: "20px" }}>
            <h1>Our Impact</h1>
            <div className="impact-heading">
              <h2 style={{ marginTop: "20px" }}>
                <span className="impact-line-1" style={{ marginTop: "20px" }}>
                  Reimagine Frontline
                </span>
                <span className="impact-line-2">workforce with</span>
                <span className="impact-line-3">Chauwk</span>
              </h2>
              <div className="impact-para">
                <p
                  style={{ color: "#4a4a4a" }}
                  ref={(el) => el && el.style.setProperty("color", "#4a4a4a", "important")}
                >
                  Chauwk delivers innovative AI and enterprise solutions that help
                  businesses automate customer interactions, optimize operations,
                  strengthen workforce engagement, and unlock scalable growth
                  opportunities.
                </p>
              </div>
            </div>

            <div className="three-buttons">
              <div className="button-container-3">
                <button className="custom-button-3">Learning</button>
                <button className="custom-button-3">Career</button>
                <button className="custom-button-3">Professional</button>
              </div>
            </div>

            <div className="impact-videos-container">
              <div className="impact-video-card">
                <iframe
                  src="https://www.youtube.com/embed/0YUeAWjX6Mg"
                  title="AI Policy/Program Chatbot"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <h3 className="impact-video-title">AI Voice Agent</h3>
              </div>

              <div className="impact-video-card">
                <iframe
                  src="https://www.youtube.com/embed/cvLdmPkLB5Y"
                  title="AI Hiring Platform"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <h3 className="impact-video-title">AI Powered Hiring Platform</h3>
              </div>

              <div className="impact-video-card">
                <iframe
                  src="https://www.youtube.com/embed/YNuHw_Y2MTs"
                  title="AI Policy/Program Chatbot"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <h3 className="impact-video-title">AI Chatbot / WhatsApp </h3>
              </div>
              <div className="impact-video-card">
                <iframe
                  src="https://www.youtube.com/embed/7U5omrNYWD8"
                  title="Training Platform"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <h3 className="impact-video-title">Online Training Platform</h3>
              </div>
            </div>


            <div className="build-for">
              <h2 style={{ position: 'relative', left: '31px' }}>Keep Workers Connected and Empowered</h2>

              <div className="build-for-box-1">
                <img src={workersConnectedImg} alt="Workers Connected" />
                <div className="text-box-1">
                  <p>Take up a Challenge to Raise Awareness</p>
                  <hr />
                </div>
              </div>
              <div className="content-for-box2">
                <h3>
                  <span className="fueling-text">
                    Fueling Worker Success with
                  </span>
                  <span className="chauwk-connections">Chauwk Connections</span>
                </h3>
              </div>

              <div className="para-box1">
                <p>
                  We envision Chauwk to be the go-to digital <br />
                  destination for the Blue and Grey collared worker
                  <br /> across the planet!
                </p>
              </div>
              <div className="build-for-box-2">
                <img
                  src={voiceAgent}
                  alt="Voice Agent"
                  className="worker-female-image"
                />
                <div className="text-box-1">
                  <p>Unlock potential to drive progress</p>
                  <hr />
                </div>
              </div>
              <div className="content-for-box2" style={{ position: 'relative', top: '20px' }}>
                <h3>
                  Strength in Every Hand Together{" "}
                  <span className="chauwk-workforce">Chauwk Workforce</span>
                </h3>
              </div>
              <div className="para-box2" style={{ position: 'relative', top: '20px' }}>
                <p>
                  Helping Enterprise to take a leap and <br /> use AI
                  technologies to unlock their potential
                  <br /> and build a brighter future.
                </p>
              </div>
            </div>
          </div>

          <div className="mobile-mockup-container">
            <MobileMockup />
          </div>

          <div className="home-footer-component">
            <Footer />
          </div>
        </div>
      </div>

      {/* Chauwk AI Voice Agent: shown on every page by GlobalVoiceAgent (App.js) */}
    </>
  );
};

export default Home;
